import { getRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const getCountriesRequest = (payload) =>
  getRequest(replaceInUrl(apiEndpoints.common.getCountries, payload));

export const getCountryStatesRequest = (payload) =>
  getRequest(replaceInUrl(apiEndpoints.common.getCountryStates, payload));

export const getAllStates = () =>
  getRequest(apiEndpoints.identificationVerification.getAllStates);

export const getAllCountries = () =>
  getRequest(apiEndpoints.identificationVerification.getAllCountries);
